/**
 * Whether an account has to confirm its email address before it can be used.
 *
 * Off for now, deliberately: SMTP is not configured, so with this on the
 * only way past sign-up was to read the verification link out of the server
 * log. Nobody could create a working account.
 *
 * Verification emails are still sent (or logged), and emailVerified is still
 * recorded, so turning this back on does not strand anyone who signed up in
 * the meantime: they are simply asked to confirm the next time they arrive.
 *
 * One switch rather than three, because the gate is enforced in three
 * places and a half-applied policy is how someone ends up with an account
 * that can sign in but not open a page.
 */
export const REQUIRE_EMAIL_VERIFICATION = false;
